// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"726":"c7ab1133","976":"fcee6f1f"}[chunkId] + ".chunk.css";
};